import { createContext, useContext, useEffect, useState } from 'react'
import { SubnavType } from 'types/Sidebar'

const SubnavContext = createContext<SubnavType[]>([])

const SubnavDispatchContext = createContext<React.Dispatch<React.SetStateAction<SubnavType[]>>>(() => {})

export function SubnavProvider({ children }) {
  const [subnav, setSubnav] = useState<SubnavType[]>([])

  return (
    <SubnavContext.Provider value={subnav}>
      <SubnavDispatchContext.Provider value={setSubnav}>{children}</SubnavDispatchContext.Provider>
    </SubnavContext.Provider>
  )
}

export function useSubnavContext() {
  return useContext(SubnavContext)
}

function useSubnavDispatch() {
  return useContext(SubnavDispatchContext)
}

export function useSubnav(subnav: SubnavType[]) {
  const subnavDispatch = useSubnavDispatch()

  useEffect(() => {
    subnavDispatch(subnav)
  }, [subnav])
}
